'use strict';

var Job = require('lib/models/Job');
var Radio = require('backbone.radio');
var apiChannel = Radio.channel('apiChannel');
var LogMessage = require('lib/models/LogMessage');
var console2 = require('lib/Console');

// Failover tests should finish within 90 seconds
var MAX_DURATION = 90000;

module.exports = Job.extend({

  defaults: {
    jobType: 'failoverTest',
    status: 'pending',
  },

  initialize: function() {
    this.startTimeout();
  },

  startTimeout: function() {
    var self = this;

    if (!this.isDone() && this.timeout === undefined) {
      this.timeout = setTimeout(function() {
        self._error(self.collection.mac, 'Job Timeout');
      }, MAX_DURATION);
    }
  },

  stopTimeout: function() {
    clearTimeout(this.timeout);
  },

  /**
   * Initiates a test failover job for a device
   *
   * @param {String} mac
   * @fires failoverTest:succeeded
   * @fires failoverTest:failed
   * @returns {jQuery.Deferred}
   */
  start: function(mac) {
    var self = this;

    this.startTimeout();

    return apiChannel
    .request('send', 'DNA.Portal.Device.doFailover', {mac: mac})
    .done(function(resp) {
      if (resp.result) {
        self.set('id', resp.result);
      } else {
        self._error(mac, 'No assigned job queue ID from DNA.Portal.Device.doFailover');
      }
    }).fail(function(err) {
      self._error(mac, err);
    });
  },

  _error: function(mac, error) {
    this.set('status', 'failed');

    var message = 'Failover test failed for ' + mac + ': ' + JSON.stringify(error);

    console2.log('warn', message);
    (new LogMessage({
      level: 'NOTICE',
      message: message,
      file: 'failoverTest.js',
    })).save();
  },
});

